export default function getEchartOptionMeasure1(data, min, max) {
	let option = {
		grid: {
			x: 0,
			y: 10,
			x2: 0,
			y2: 0,
			containLabel: true
		},
		tooltip: {
			trigger: "item",
			backgroundColor: 'rgba(255, 255, 255, 0.95)',
			borderColor: "#D8E2F8",
			borderWidth: 1,
			borderRadius: 4,
			textStyle: {
				color: "#8394B9",
				fontSize: 14
			},
			confine: true,
			formatter: function (val) {

				if (!val) {
					return null;
				}

				// 1.获取当前点附近的点位
				let dataIndex = val.dataIndex;
				let componentIndex = val.componentIndex;

				// 2.公共数据
				let extra = JSON.parse(JSON.stringify(val.data.extra));
				let date = extra.date || '';
				let categoryName = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? '收缩压' : '舒张压') : (extra.fType === 'oxygenSaturation' ? '血氧' : extra.fType === 'pulseRate' ? '脉率' : '体温');
				let topView = getTopView(date, categoryName);

				let nearbyArr = [];

				let diff = 0;
				if (extra.fType === 'bodyTemperature') {
					diff = 0;
				}

				for (let i = 0; i < data.series.length; i++) {
					if (i != componentIndex) {
						let item = data.series[i];
						if (item.data[dataIndex].value !== null && item.data[dataIndex].value != 0 && item.data[dataIndex].value !== '-') {
							if (Number(val.value) >= Number(item.data[dataIndex].value)) {
								if (Number(val.value) - Number(item.data[dataIndex].value) <= diff) {
									nearbyArr.push(JSON.parse(JSON.stringify(item.data[dataIndex])));
								}
							} else if (Number(val.value) < Number(item.data[dataIndex].value)) {
								if (Number(item.data[dataIndex].value) - Number(val.value) <= diff) {
									nearbyArr.push(JSON.parse(JSON.stringify(item.data[dataIndex])));
								}
							}
						}
					}
				}

				// 3.判断附近是否存在其他点 || 单点+多时段
				if ((nearbyArr.length == 0) && (!val.data.extra.itemRecordList || val.data.extra.itemRecordList.length == 0)) { // 小浮窗样式
					let dotColor = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? (extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)') : (extra.itemAbnormal2Avg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)')) : (extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)');
					let time = extra.timeAvg || '';
					let textValue = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? extra.itemValueAvg : extra.itemValue2Avg) : extra.itemValueAvg;
					let textColor = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? (extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)') : (extra.itemAbnormal2Avg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)')) : (extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)');
					let unit = extra.fType === 'oxygenSaturation' ? '%' : extra.fType === 'bodyTemperature' ? '°C' : '';
					let dotValView = `
					<div style="display: flex; align-items: center; margin-top: 5px;">
						${getDotView(dotColor)}
						${getTimeView(time)}
						${getValueView(textColor, textValue, unit)}
					</div>
					`
					return topView + dotValView;
				} else { // 大浮窗样式
					nearbyArr.unshift(JSON.parse(JSON.stringify(val.data)));

					nearbyArr = sortNearbyArr(nearbyArr);

					let contentView = ``;

					for (let i = 0; i < nearbyArr.length; i++) {
						let item = nearbyArr[i];
						let single_extra = item.extra;
						let dotColor = single_extra.fType === 'bloodPressure' ? (single_extra.sType === 'systolicBloodPressure' ? (single_extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)') : (single_extra.itemAbnormal2Avg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)')) : (single_extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)');
						let time = single_extra.timeAvg || '';
						let textValue = single_extra.fType === 'bloodPressure' ? (single_extra.sType === 'systolicBloodPressure' ? single_extra.itemValueAvg : single_extra.itemValue2Avg) : single_extra.itemValueAvg;
						let textColor = single_extra.fType === 'bloodPressure' ? (single_extra.sType === 'systolicBloodPressure' ? (single_extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)') : (single_extra.itemAbnormal2Avg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)')) : (single_extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)');
						let unit = single_extra.fType === 'oxygenSaturation' ? '%' : single_extra.fType === 'bodyTemperature' ? '°C' : '';
						let max_width = single_extra.fType === 'bloodPressure' ? (single_extra.sType === 'systolicBloodPressure' ? '260px' : '260px') : (single_extra.fType === 'oxygenSaturation' ? '305px' : single_extra.fType === 'pulseRate' ? '260px' : '320px');;

						let singleView = `
							<div style="display: flex;">
								<span style='display:inline-block;margin-right:5px;margin-left:0px; margin-top: 10px; border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>
								<div class="echartOptionMeasure1" style="display: flex; align-items: center; margin-top: 5px; max-width: ${max_width}; flex-wrap: wrap;">
									${getTimeView(time)}
									${single_extra.itemRecordList && single_extra.itemRecordList.length > 0 ? getAverageTextView() : ''}
									${getValueView(textColor, textValue, unit)}
						`;
						let colonView = ``;

						if (single_extra.itemRecordList && single_extra.itemRecordList.length > 0) {
							colonView = `
								<span style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(38, 38, 38, 1); line-height: 17px;'>${'：'}</span>
							`
							singleView += colonView;

							for (let j = 0; j < single_extra.itemRecordList.length; j++) {
								let jObject = single_extra.itemRecordList[j];
								let jObject_time = jObject.time || '-';
								let jObject_value = single_extra.fType === 'bloodPressure' ? (single_extra.sType === 'systolicBloodPressure' ? jObject.itemValue : jObject.itemValue2) : (jObject.itemValue);
								let jObject_value_color = single_extra.fType === 'bloodPressure' ? (single_extra.sType === 'systolicBloodPressure' ? (jObject.itemAbnormal == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(177, 178, 178, 1)') : (jObject.itemAbnormal2 == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(177, 178, 178, 1)')) : (jObject.itemAbnormal == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(177, 178, 178, 1)');
								singleView += `
									<div style="display: flex; align-items: center;">
										<span style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${jObject_value_color}; line-height: 17px;'>${jObject_value}${unit}</span>
										<span style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(177, 178, 178, 1); line-height: 17px;'>(${jObject_time})${j != single_extra.itemRecordList.length - 1 ? '、': ''}</span>
									</div>
								`
							}
						}

						singleView += `</div></div>`;

						singleView += nearbyArr.length > 1 && i < nearbyArr.length - 1 ? `<div style="margin-top: 5px; height: 1px; background: rgba(38, 38, 38, 0.1);"></div>` : ``;

						contentView += singleView;
					}

					return topView + contentView;
				}


				return '123'



				// 2.区分单点还是重叠点位
				if ((!nearbyArr || nearbyArr.length == 0)) {

				} else {
					if (!val.data || !val.data.extra) return null;

					let extra = JSON.parse(JSON.stringify(val.data.extra));

					// 获取单位
					let unit = extra.fType === 'oxygenSaturation' ? '%' : extra.fType === 'bodyTemperature' ? '°C' : '';

					// 获取日期
					let date = extra.date || '';

					// 获取时间点
					let time = extra.timeAvg || '';

					// 获取值(itemValueAvg：收缩压，itemValue2Avg： 舒张压)
					let tip_title = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? '收缩压' : '舒张压') : (extra.fType === 'oxygenSaturation' ? '血氧' : extra.fType === 'pulseRate' ? '脉率' : '体温');
					let tip_value = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? extra.itemValueAvg : extra.itemValue2Avg) : extra.itemValueAvg;
					let tip_value_color = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? (extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(38, 38, 38, 1)') : (extra.itemAbnormal2Avg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(38, 38, 38, 1)')) : (extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(38, 38, 38, 1)');
					let dotColor = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? (extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)') : (extra.itemAbnormal2Avg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)')) : (extra.itemAbnormalAvg == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(24, 144, 255, 1)');

					// dot + value 样式
					let dotValView = `
					<div style="display: flex; align-items: center; margin-top: 5px;">
						${getDotView(dotColor)}
						<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(38, 38, 38, 1); line-height: 17px;'>${time}</div>
						<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${tip_value_color}; line-height: 17px; margin-left: 5px;'>${tip_value}${unit}</div>
					</div>
					`

					if (!extra.itemRecordList || extra.itemRecordList.length == 0) {
						return getTopView(date, tip_title) + dotValView;
					}

					// 分割线
					let splitLine = `<div style="width: 100%; height: 1px; margin-top: 10px; margin-bottom: 10px; background: rgba(161, 210, 253, 0.3);"></div>`

					let bottomView = '';
					for (let i = 0; i < extra.itemRecordList.length; i++) {
						let item = extra.itemRecordList[i];
						let item_time = item.time || '-';
						let item_value = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? item.itemValue : item.itemValue2) : (item.itemValue);
						let item_value_color = extra.fType === 'bloodPressure' ? (extra.sType === 'systolicBloodPressure' ? (item.itemAbnormal == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(38, 38, 38, 1)') : (item.itemAbnormal2 == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(38, 38, 38, 1)')) : (item.itemAbnormal == 1 ? 'rgba(255, 113, 134, 1)' : 'rgba(38, 38, 38, 1)');
						let itemView = `
						<div style="display: flex; align-items: center; margin-top: 5px;">
							<span style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(38, 38, 38, 1); line-height: 17px;'>${item_time}</span>
							<span style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${item_value_color}; line-height: 17px; margin-left: 5px;'>${item_value}${unit}</span>
						</div>
						`;
						bottomView += itemView;
					}

					return getTopView(date, time) + dotValView + splitLine + bottomView;
				}

				return null;

			}
		},
		xAxis: {
			type: 'category',
			data: data.xAxis_data || [],
			axisTick: {
				show: false,
			},
			axisLabel: {
				textStyle: {
					color: "rgba(165, 169, 188, 1)", //坐标的字体颜色
					fontSize: 10
				}
			},
			axisLine: {
				lineStyle: {
					color: "rgba(144, 148, 166, 1)",
					type: "solid",
				},
			},
		},
		yAxis: {
			type: 'value',
			min: min,
			axisLine: {
				show: false,
			},
			axisLabel: { // 坐标轴刻度标签的相关设置。
				show: true,
				textStyle: {
					color: "rgba(165, 169, 188, 1)",
					fontSize: 10
				},
			},
		},
		series: data.series,
	}

	if (max) {
		option.yAxis.max = max;
	}

	return option;
}


// 日期 + 类型
function getTopView(date, time) {
	return `
		<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(38, 38, 38, 1); line-height: 17px;'>
			<span>${date}</span>
			<span>${time}</span>
		</div>
	`
}

// 圆点
function getDotView(dotColor) {
	return `<span style='display:inline-block;margin-right:5px;margin-left:0px;border-radius:10px;width:6px;height:6px;background-color:${dotColor}'></span>`;
}

// 时间
function getTimeView(time) {
	return `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(38, 38, 38, 1); line-height: 17px; margin-right: 5px;'>${time}</div>`;
}

// 数值
function getValueView(textColor, value, unit) {
	return `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: ${textColor}; line-height: 17px;'>${value}${unit}</div>`;
}

// 平均文本
function getAverageTextView() {
	return `<div style='font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: rgba(38, 38, 38, 1); line-height: 17px;'>平均</div>`;
}

function sortNearbyArr(nearbyArr) {
    // 复制原数组避免修改原数据
    const sortedArr = [...nearbyArr];
    
    // 按照timeAvg时间排序
    sortedArr.sort((a, b) => {
        // 解析时间字符串为分钟数（如"20:50" -> 20*60+50=1250）
        const getMinutes = (timeStr) => {
            const [hours, minutes] = timeStr.split(':').map(Number);
            return hours * 60 + minutes;
        };
        
        const timeA = getMinutes(a.extra.timeAvg);
        const timeB = getMinutes(b.extra.timeAvg);
        
        // 升序排列（从小到大）
        return timeA - timeB;
    });
    
    return sortedArr;
}